<form #orderTermsForm="ngForm" name="orderTermsForm" class="form-v2">
    <div class="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
    </div>
    <div class="modal-body">
        <div class="row" *ngIf="type === 'purchase'">
            <div class="btn-group btn-group-xs margin-bottom-10">
                <button
                    id="show-supplier-terms-btn"
                    [ngClass]="isShowingSupplierTerms ? 'btn-bx-secondary' : 'btn-bx-secondary-stroked'"
                    class="mr-1"
                    type="button"
                    (click)="showSupplierTerms()">
                    Suppliers
                </button>
                <button
                    id="show-contractor-terms-btn"
                    [ngClass]="isShowingContractorTerms ? 'btn-bx-secondary' : 'btn-bx-secondary-stroked'"
                    class="mr-1"
                    type="button"
                    (click)="showContractorTerms()">
                    Contractors
                </button>
            </div>
            <div id="supplierTermsTab" *ngIf="isShowingSupplierTerms" class="form-group">
                <textarea
                    legacy-css
                    rows="20"
                    class="form-control"
                    id="orderTerms"
                    name="orderTerms"
                    [(ngModel)]="termsAndConds.orderTerms"></textarea>
            </div>
            <div id="contractorTermsTab" *ngIf="isShowingContractorTerms" class="form-group">
                <textarea
                    legacy-css
                    rows="20"
                    class="form-control"
                    id="orderTermsContractor"
                    name="orderTermsContractor"
                    [(ngModel)]="termsAndConds.orderTermsContractor"></textarea>
            </div>
        </div>
        <div class="row" *ngIf="type === 'work'">
            <div class="col-xs-12">
                <div class="form-group">
                    <label>Work Order Terms</label>
                    <textarea
                        legacy-css
                        rows="20"
                        class="form-control"
                        id="orderTermsWork"
                        name="orderTermsWork"
                        [(ngModel)]="termsAndConds.orderTermsWork"></textarea>
                </div>
            </div>
        </div>
        <div class="row margin-top-10">
            <div class="col-xs-12">
                <div class="form-group">
                    <div class="col-sm-9">
                        <div class="checkbox">
                            <input
                                legacy-css
                                type="checkbox"
                                id="isTermsOnSeparatePage"
                                [(ngModel)]="termsAndConds.isTermsOnSeparatePage"
                                [ngModelOptions]="{ standalone: true }" />
                            <label for="isTermsOnSeparatePage" class="padding-left-0"> When printing, show terms on a separate page </label>
                        </div>
                    </div>
                    <div class="col-sm-3 text-right">
                        <button type="button" class="btn btn-default" id="resetOrderTermsBtn" (click)="resetOrderTermsSettings()">
                            <i class="ti-reload"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer new">
        <button type="button" class="btn-bx-secondary-stroked" id="orderTermsCancelBtn" (click)="cancel()">Cancel</button>
        <button type="button" class="btn-bx-primary ml-2" id="orderTermsOkBtn" (click)="ok()">Save &amp; Close</button>
    </div>
</form>
